module.exports = __webpack_public_path__ + "img/creamy-mobile.9af9fd98.jpg";